import React, { useState, useEffect } from 'react';
import { getDocPersons } from "../../../api/papers";

export default function PeopleView({ 
    dns, 
    placeholder = "담당자가 지정되지 않았습니다.",
}) {
    const [value, setValue] = useState([]); 
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!dns) {
            setIsLoading(false);
            return;
        }

        const loadPeople = async () => {
            setIsLoading(true);
            try {
                const list = await getDocPersons(dns); 
                console.log("로드된 담당자:", list);

                const mapped = list.map((p) => ({
                    id: p.id,
                    name: p.name || `${p.user.last_name ?? ""}${p.user.first_name ?? ""}`,
                    // company: p.user.company,
                    // department: p.user.department,
                    // position: p.user.position,
                }));
                
                setValue(mapped);
            } catch (error) {
                console.error("담당자 로드 오류:", error);
                setValue([]);
            } finally {
                setIsLoading(false);
            }
        };
        loadPeople();
    }, [dns]);

    if (isLoading) {
        return (
            <div className="py-1 text-sm text-gray-500">
                담당자 정보를 로드 중입니다...
            </div>
        );
    }
    
    if (value.length === 0) {
        return (
            <div className="py-1 text-sm text-gray-500">
                {placeholder}
            </div>
        );
    }
    
    const names = value.map(person => person.name).join(', ');

    return (
        <div className="w-full">
            <div className="flex flex-wrap gap-2 text-body">
                {names}
            </div>
        </div>
    );
}